<template>
    <div>

        <kgr-loading v-if="loadingConfig" />
        <kgr-basfi-reporting-table
            v-else-if="config !== null"
            :config="config"
            :context="'kindergarten'"
        />
    </div>
</template>

<script>
import BasfiKindergartenConfigRepository from '../../js/repository/BasfiKindergartenConfigRepository';
import BasfiReporting from './Reporting.vue';
import Loading from '../../components/common/Loading';

export default {
    components: {
        'kgr-basfi-reporting-table': BasfiReporting,
        'kgr-loading': Loading,
    },
    props: {
        kindergartenId: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            loadingConfig: false,
            config: null
        }
    },
    created() {
        this.loadingConfig = true;
        BasfiKindergartenConfigRepository.findByKindergartenId(this.kindergartenId)
            .then(config => {
                this.config = config;
                this.loadingConfig = false;
            })
    },
}
</script>
